import { render, staticRenderFns } from "./detailsTab.vue?vue&type=template&id=fdec98d0&scoped=true"
import script from "./detailsTab.vue?vue&type=script&lang=js"
export * from "./detailsTab.vue?vue&type=script&lang=js"
import style0 from "./detailsTab.vue?vue&type=style&index=0&id=fdec98d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdec98d0",
  null
  
)

export default component.exports